import React from "react";
import { ServiceHeroWrap } from "./ServiceHero.styled";

const ServiceHero = () => {
  return (
    <section>
      <ServiceHeroWrap>
        <div>
          <h2>Services</h2>
        </div>
      </ServiceHeroWrap>
    </section>
  );
};

export default ServiceHero;
